import { useTranslation } from 'react-i18next';
import styles from './NotFoundPage.module.css';

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <main className={styles.wrap}>
      <div className="container">
        <p className={styles.code}>404</p>
        <h1>{t('notFound.title')}</h1>
        <p className="lead text-soft">{t('notFound.body')}</p>
        <a className="btn btn--primary" href="/">
          {t('notFound.back')}
        </a>
      </div>
    </main>
  );
}
